import { useState, useCallback, useEffect } from "react";
import { Star, ChevronLeft, ChevronRight, ArrowLeft, Phone, Video } from "lucide-react";
import useEmblaCarousel from "embla-carousel-react";

const TESTIMONIALS = [
  {
    name: "Larissa Aparecida",
    time: "15:00",
    text: "Amine Festa é uma das melhores empresas quando o quesito é decoração personalizada. Possui uma equipe caprichosa, super capacitada e atenciosa, a qual pensa sempre nos mínimos detalhes (o que faz bastante diferença na decoração). É uma empresa que entrega tudo pronto, sem que a gente precise se preocupar com nada no dia do evento. Tudo é pensado e desenvolvido com muito carinho o que faz o resultado final ser sempre surpreendente. Por este motivo é uma empresa que está sempre presente nos aniversários do meu filho.",
  },
  {
    name: "Bruno Luan",
    time: "14:43",
    text: "Conheci o talento da Amine antes mesmo de o sonho de montar a loja se realizar, e já admirava o cuidado e a criatividade que ela colocava em cada projeto. Quando chegou o aniversário de 4 anos do meu filho, Gael, não tive dúvidas em confiar nela para transformar esse momento em algo mágico. Desde então, acompanhei a evolução e o sucesso da loja, que a cada ano supera as expectativas com trabalhos incríveis. Hoje, com o Gael completando 8 anos, só tenho a agradecer pelas memórias inesquecíveis que ela ajudou a criar. Recomendo de coração a quem busca decoração feita com alma e paixão!",
  },
  {
    name: "Bruna Diniz",
    time: "10:28",
    text: "Amine e equipe, quero agradecer primeiramente pelo atendimento, desde o início, super solícito e paciente. A mesa do bolo ficou melhor que esperávamos! Com detalhes personalizados com a identidade visual da festa. E a decoração entrada da festa? Que perfeiçãooooo! Logo na entrada, deu um efeito uauuu!!! Tudo ficou simplesmente impecável. Tudo muito bem pensado, harmônico e com a identidade da festa boteco que sonhamos. Vocês transformaram a recepção dos convidados em uma experiência linda e marcante. Obrigada por tanto cuidado e capricho nesse dia tão especial!",
  },
  {
    name: "Maryse Nogueira",
    time: "20:32",
    text: "Amine, muito obrigada pela decoração! Todo mundo amou! Já passei sua indicação! Depois eu mando as fotos! Obrigada pelo compromisso e cuidado.",
  },
  {
    name: "Priscilla Emrich",
    time: "17:45",
    text: "Que amorrr!!! A gente ficou suuuuuuper feliz! Todos elogiaram demais a decoração. Arrasaram!!!",
  },
  {
    name: "Nayara Garcia",
    time: "09:19",
    text: "Gostaria de expressar minha gratidão pelo excelente atendimento ao cliente que recebi da equipe Amine festa. Vocês realmente se esforçam para garantir a satisfação da minha pequena. Eu sempre recomendo sua empresa para amigos e familiares, pois sei que eles ficarão satisfeitos com o serviço.",
  },
  {
    name: "Neila Abadio",
    time: "15:23",
    text: "Nasci em uma família festeira e, depois que tive meus filhos, esse encantamento cresceu ainda mais! Gosto de montar cada aniversário com detalhes e requintes que eu só encontrei na AMINE FESTAS. Desde o primeiro contato até a entrega da festa. É tudo maravilhoso! Os balões, o mobiliário, a montagem... Tudo é feito delicadeza e carinho. Obrigada equipe AMINE FESTAS, por sonharem comigo e realizarem, de forma exclusiva, as minhas festas!",
  },
];

const AVATAR_COLORS = ["#E4077B", "#00929A", "#f39200", "#6b5ce7", "#2ecc71", "#e67e22", "#9b59b6"];
const MAX_CHARS = 260;

const whatsappWallpaper = {
  backgroundColor: "#e5ddd5",
  backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23c9bfb0' fill-opacity='0.15'%3E%3Ccircle cx='8' cy='8' r='1.5'/%3E%3Ccircle cx='38' cy='12' r='1'/%3E%3Ccircle cx='22' cy='38' r='1.5'/%3E%3Ccircle cx='52' cy='45' r='1'/%3E%3Cpath d='M15 25 l3-3 3 3' fill='none' stroke='%23c9bfb0' stroke-opacity='0.15' stroke-width='1'/%3E%3Cpath d='M42 28 l2-4 2 4' fill='none' stroke='%23c9bfb0' stroke-opacity='0.15' stroke-width='1'/%3E%3Crect x='48' y='8' width='3' height='3' rx='0.5' fill='none' stroke='%23c9bfb0' stroke-opacity='0.12' stroke-width='0.8'/%3E%3Crect x='5' y='48' width='3' height='3' rx='0.5' fill='none' stroke='%23c9bfb0' stroke-opacity='0.12' stroke-width='0.8'/%3E%3C/g%3E%3C/svg%3E")`,
};

function WhatsAppCard({ name, time, text, colorIndex }) {
  const [expanded, setExpanded] = useState(false);
  const needsTruncation = text.length > MAX_CHARS;
  const displayText = !expanded && needsTruncation ? text.slice(0, MAX_CHARS) + "..." : text;
  const color = AVATAR_COLORS[colorIndex % AVATAR_COLORS.length];

  return (
    <div
      className="rounded-xl overflow-hidden shadow-lg border border-gray-200/60 flex flex-col"
      style={{ height: expanded ? "auto" : "380px", minHeight: "380px" }}
      data-testid="testimonial-card"
    >
      {/* Top Bar */}
      <div className="bg-[#075e54] px-3 py-2.5 flex items-center gap-2.5">
        <ArrowLeft size={18} className="text-white/80 flex-shrink-0" />
        <div
          className="w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0"
          style={{ backgroundColor: color }}
        >
          {name.charAt(0)}
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-white text-[13px] font-medium truncate leading-tight">{name}</p>
          <p className="text-white/60 text-[10px] leading-tight">online</p>
        </div>
        <Video size={17} className="text-white/70 flex-shrink-0" />
        <Phone size={15} className="text-white/70 flex-shrink-0" />
      </div>

      {/* Chat Body */}
      <div className="flex-1 px-3 py-3 flex flex-col" style={whatsappWallpaper}>
        {/* Received message bubble - WHITE, LEFT aligned */}
        <div className="relative max-w-[92%] self-start">
          {/* Tail */}
          <div
            className="absolute -left-1.5 top-0 w-3 h-3"
            style={{
              background: "white",
              clipPath: "polygon(100% 0, 0 0, 100% 100%)",
            }}
          />
          <div className="bg-white rounded-lg rounded-tl-none px-3 py-2 shadow-sm">
            <p className="text-[13px] leading-[1.5] text-[#111b21]" style={{ fontFamily: "'Segoe UI', Helvetica, Arial, sans-serif" }}>
              {displayText}
              {needsTruncation && !expanded && (
                <button
                  onClick={() => setExpanded(true)}
                  className="text-[#027eb5] font-medium ml-1 text-[13px] hover:underline"
                  data-testid="testimonial-expand-btn"
                >
                  ver mais
                </button>
              )}
            </p>
            <div className="flex justify-end mt-0.5">
              <span className="text-[10px] text-[#667781]">{time}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Testimonials() {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: "start",
    loop: false,
    slidesToScroll: 1,
  });
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(false);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setCanPrev(emblaApi.canScrollPrev());
    setCanNext(emblaApi.canScrollNext());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);
    return () => {
      emblaApi.off("select", onSelect);
      emblaApi.off("reInit", onSelect);
    };
  }, [emblaApi, onSelect]);

  return (
    <section id="depoimentos" data-testid="testimonials-section" className="py-24 bg-[#f9f9f9]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-12">
          <span className="text-[#f39200] text-xs tracking-[0.25em] uppercase font-medium">Reviews</span>
          <h2
            className="text-3xl sm:text-4xl font-light text-[#1a1a1a] tracking-tight mt-3"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            O que dizem nossos clientes
          </h2>
          <div className="w-12 h-0.5 bg-[#f39200] mx-auto mt-4 mb-4" />
          <div className="flex items-center justify-center gap-1">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={18} className="text-[#f39200] fill-[#f39200]" />
            ))}
          </div>
        </div>

        {/* Carousel */}
        <div className="relative">
          <div className="overflow-hidden" ref={emblaRef}>
            <div className="flex gap-5">
              {TESTIMONIALS.map((t, i) => (
                <div
                  key={i}
                  className="flex-[0_0_100%] sm:flex-[0_0_calc(50%-10px)] lg:flex-[0_0_calc(33.333%-14px)]"
                >
                  <WhatsAppCard {...t} colorIndex={i} />
                </div>
              ))}
            </div>
          </div>

          {/* Desktop Arrows */}
          <button
            onClick={() => emblaApi?.scrollPrev()}
            disabled={!canPrev}
            data-testid="testimonials-prev-btn"
            className={`hidden md:flex absolute -left-5 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white shadow-md items-center justify-center transition-all ${canPrev ? "opacity-100 hover:bg-[#075e54] hover:text-white" : "opacity-30 cursor-default"}`}
          >
            <ChevronLeft size={20} />
          </button>
          <button
            onClick={() => emblaApi?.scrollNext()}
            disabled={!canNext}
            data-testid="testimonials-next-btn"
            className={`hidden md:flex absolute -right-5 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white shadow-md items-center justify-center transition-all ${canNext ? "opacity-100 hover:bg-[#075e54] hover:text-white" : "opacity-30 cursor-default"}`}
          >
            <ChevronRight size={20} />
          </button>
        </div>
      </div>
    </section>
  );
}
